import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles, Hidden } from '@material-ui/core';
import NavBar from './NavBar';
import TopBar from './TopBar';
import BotOperations from './BotOperations';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getBot } from 'src/actions/botsActions';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    width: '100%'
  },
  wrapper: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    paddingTop: 54,
    [theme.breakpoints.up('lg')]: {
      paddingTop: 0
    }
  },
  contentContainer: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden'
  },
  content: {
    flex: '1 1 auto',
    height: '100%',
    overflow: 'auto'
  }
}));

function DashboardLayout({ children }) {
  const classes = useStyles();
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  const { botId } = useParams();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getBot(botId));
  }, [dispatch, botId]);
  return (
    <div className={classes.root}>
      <Hidden lgUp>
        <TopBar onMobileNavOpen={() => setMobileNavOpen(true)} />
      </Hidden>
      <NavBar
        onMobileClose={() => setMobileNavOpen(false)}
        openMobile={isMobileNavOpen}
      />
      <div className={classes.wrapper}>
        <div className={classes.contentContainer}>
          <div className={classes.content}>{children}</div>
        </div>
      </div>
      <BotOperations />
    </div>
  );
}

DashboardLayout.propTypes = {
  children: PropTypes.any
};

export default DashboardLayout;
